import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OauthClientDTO, OauthClientsService } from '../../../../shared/oauth-oidc-client/oauth-clients.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { SubscriptionsManager } from '../../../../shared/util/subscriptions-manager';
import { AlertService } from '../../../../shared/alert/alert.service';

@Component({
    selector: 'jhi-oauth-client-edit-modal',
    templateUrl: './oauth-client-edit-modal.component.html',
    styleUrl: './oauth-client-edit-modal.component.scss'
})
export class OauthClientEditModalComponent implements OnInit, OnDestroy {

    @Input() oauthClient: OauthClientDTO = {
        id: undefined,
        clientId: '',
        redirectUri: '',
        description: ''
    };
    protected isLoading: unknown;
    protected subscriptionsManager = new SubscriptionsManager();

    constructor(private activeModal: NgbActiveModal,
                private oauthClientsService: OauthClientsService,
                private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {

    }

    protected clear() {
        this.activeModal.dismiss();
    }

    protected save() {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        if (this.oauthClient.id === undefined) {
            this.subscriptionsManager.add = this.oauthClientsService.create(this.oauthClient).subscribe({
                next: response => {
                    this.isLoading = false;
                    this.activeModal.close();
                    this.alertService.success('site-admin.oauth-clients.add.success', { param: this.oauthClient.clientId });
                },
                error: () => {
                    this.isLoading = false;
                }
            });
        } else {
            this.subscriptionsManager.add = this.oauthClientsService.update(this.oauthClient.id, this.oauthClient).subscribe({
                next: response => {
                    this.isLoading = false;
                    this.activeModal.close();
                    this.alertService.success('site-admin.oauth-clients.edit.success', { param: this.oauthClient.clientId });
                },
                error: () => {
                    this.isLoading = false;
                }
            });
        }
    }

    protected isFormValid(f: NgForm): boolean {
        return f && f.form && f.form.valid;
    }
}
